import * as loadjs from 'loadjs';
export default function (baseUrl: string, target: HTMLElement) {
    loadjs([
        baseUrl + '/bootstrap-select/dist/js/bootstrap-select.min.js',
        baseUrl + '/bootstrap-select/dist/css/bootstrap-select.min.css',
    ], {
        success: function () {
            if (target.tagName != "SELECT") {
                throw new Error("only select is allowed for data-gs-chosen");
            }
            //for multiply select, remove the empty choice
            if ((<HTMLSelectElement>target).multiple) {
                let firstOption = (<HTMLSelectElement>target).options[0];
                if (!firstOption.value) {
                    firstOption.remove();
                }
            }
            (<any>$(target)).selectpicker();
        }
    });
}
